import angular from 'angular';
import 'angular-ui-router';
import GameDevelopers from './gameDevelopers/gameDevelopers';
import Games from './games/games';
import Users from './users/users';
import BidPrices from './bidPrices/bidPrices';

export default angular.module('app.components.admin', [
  'ui.router',
  BidPrices.name,
  GameDevelopers.name,
  Games.name,
  Users.name
])
  .config(function($stateProvider){
    $stateProvider
      .state('app.admin', {
        abstract: true,
        url: '/admin',
        template: '<ui-view/>',
        data: {
          permissions: {
            only: ['ADMIN', 'GG_ACCOUNT_MANAGER', 'OPERATION_MANAGER']
          }
        }
      })
  })


/** WEBPACK FOOTER **
 ** ./src/components/admin/admin.js
 **/